interface IMailIconProps {
  mainColor?: string;
  secondaryColor?: string;
  className?: string;
  onClick?: () => void;
}

const MailIcon: React.FC<IMailIconProps> = ({
  mainColor,
  secondaryColor,
  className,
}) => (
  <svg
    width="61"
    height="61"
    viewBox="0 0 61 61"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g fill="none" fillRule="evenodd">
      <path
        style={{ fill: mainColor || 'var(--tt-dark-purple)' }}
        d="M17.57 45.762v12.55l5.02-7.53 10.04 7.53 27.61-47.69-2.51-2.51z"
      />
      <path
        style={{ fill: secondaryColor || 'var(--tt-yellow)' }}
        d="M55.22 5.601 0 28.191l15.06 12.55 42.67-32.63z"
      />
    </g>
  </svg>
);

export default MailIcon;
